/**
 * Constants for Redi Health Partnership feature
 */

export const REDI_ASSISTANCE_PROGRAM_PID = "Redi Adherence Program";

/**
 * Action types for Redi invitation triggers
 * Used to track what FN action triggered the Redi modal display
 */
export const REDI_ACTION_TYPES = {
  // Triggered when patient application status changes (e.g., Enrolled → Active)
  STATUS_CHANGE: "status-change",

  // Triggered when FN manually adds a new assistance program
  MANUAL_ADD_PROGRAM: "manual-add-program",

  // Triggered from bulk send operations
  BULK_SEND: "bulk-send",

  // Triggered when user returns from MPD after editing contact info from CommunicationSettings.
  // Bypasses the 24h cooldown and max-display count so the user can complete the flow.
  CONTACT_EDIT_RETURN: "contact-edit-return"
};

export const RETRIGGER_REDI_PARAM = "retriggerRedi";

/**
 * Used when the user navigates to MPD specifically to edit/add contact info
 * from the CommunicationSettings screen (not from the missing-contact banner).
 * On return, the Redi popup is re-triggered with CONTACT_EDIT_RETURN action
 * so display limits are bypassed.
 */
export const RETRIGGER_REDI_AFTER_EDIT_PARAM = "retriggerRediAfterEdit";

export const REDI_SKIP_REASONS = {
  MISSING_CONTACT_INFO: "missing_contact_info"
};

/** The hash anchor used to auto-scroll to the Contact Details section on MPD. */
export const MPD_CONTACT_SECTION_HASH = "#manage-patient-contact-details";
